<template>
    <section class="mt-16">
      <v-breadcrumbs
          v-if="this.$root.$vuetify.theme.isDark"
          large
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
        <v-breadcrumbs
          v-else
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-hard-hat</v-icon> <span>{{$t('indirect_work_hand.crumb_edit')}}</span>
        </h1>
  
        <div class="mt-16">
          <v-progress-linear v-if="loading"
            indeterminate
            class="global-loader"
          ></v-progress-linear>
  
          <template v-if="loading">
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row class="mt-6" align="center" justify="space-around">
              <v-skeleton-loader
                  type="button"
                ></v-skeleton-loader>
            </v-row>
          </template>
            <IndirectWorkHand v-else method="update" :indirect="indirect" :style="this.$root.$vuetify.theme.isDark ? '' : 'background-color: rgba(255, 255, 255, 0.75) !important;'">
            </IndirectWorkHand>
        </div>
    </section>
  </template>
  <script>
  import IndirectWorkHand from '@/components/indirectWorkHand/IndirectWorkHand'
  import Indirect from "@/api/Indirect.js";
  
  export default {
    components: {
      IndirectWorkHand
    },
    beforeCreate(){
      document.title = "Report Lake - " + this.$t('indirect_work_hand.crumb_edit');
    },
    data: () => ({
        indirect: {},
        loading:true
    }),
    mounted(){
      if(!this.$root.session.hasPermission(["super", "indirect_work_hand.update"])) {
        this.$router.push('/admin');
      }
  
      Indirect.find(this.$route.params.id).then(({data}) => { this.indirect = data; this.loading = false;});
    },
    methods:{
      
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin',
            exact: true,
          },
          {
            text: this.$t('indirect_work_hand.crumb_edit'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin/budgeting/indirect_work_hand',
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  